import React from "react";

const ProfileIcon = () => {
  return <span className="prof-icon icon-profile_account" />;
};

export default ProfileIcon;
